module.exports = __webpack_public_path__ + "static/img/cstSer_bg_white_04.76554dce.svg";